import React from "react";
import Box from "@mui/material/Box";

import ChargesSummaryModals from "./ChargesSummaryModals/ChargesSummaryModals";

export const shoppingBackground = "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)";

export const stickyHeaderSx = {
  position: "sticky",
  top: 0,
  zIndex: (theme) => theme.zIndex.appBar,
  background: shoppingBackground,
};

const background = shoppingBackground;

const styles = {
  root: {
    background,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  contentContainer: {
    background,
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
  },
};

export default function ShoppingLayout({ children }) {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.wrapper}>
        <Box sx={styles.contentContainer}>
          <Box sx={styles.content}>
            {children}
            <ChargesSummaryModals />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
